import type { RowData, Table as TanStackTable } from "@tanstack/table-core";
import { Virtualizer } from "@tanstack/virtual-core";
import { containerGridStyles } from "../utils/grid";
import { TableHeadRow } from "./row";

interface TableHeadProps<D extends RowData> {
  columnVirtualizer: Virtualizer<HTMLDivElement, HTMLTableCellElement>;
  table: TanStackTable<D>;
  virtualPaddingLeft: number | undefined;
  virtualPaddingRight: number | undefined;
}
export function TableHead<D extends RowData>({
  columnVirtualizer,
  table,
  virtualPaddingLeft,
  virtualPaddingRight,
}: TableHeadProps<D>) {
  return (
    <thead
      className="text-sm bg-white"
      style={{
        display: "grid",
        position: "sticky",
        top: 0,
        zIndex: 1,
        justifyItems: "stretch",
        ...containerGridStyles
      }}
    >
      {table.getHeaderGroups().map((headerGroup) => (
        <TableHeadRow
          columnVirtualizer={columnVirtualizer}
          headerGroup={headerGroup}
          key={headerGroup.id}
          virtualPaddingLeft={virtualPaddingLeft}
          virtualPaddingRight={virtualPaddingRight}
        />
      ))}
    </thead>
  );
}
